import PropTypes from 'prop-types';
import { Map } from 'immutable';
import isString from 'lodash/isString';
import { WidgetPreviewContainer } from 'decap-cms-ui-default';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function toValue(value, field) {
  if (isString(value)) {
    return value;
  }
  if (Map.isMap(value)) {
    return value.get(field.getIn(['keys', 'code'], 'code'), '');
  }
  return '';
}
function CodePreview(props) {
  return _jsx(WidgetPreviewContainer, {
    children: _jsx("pre", {
      children: _jsx("code", {
        children: toValue(props.value, props.field)
      })
    })
  });
}
CodePreview.propTypes = {
  value: PropTypes.node
};
export default CodePreview;